import Head from "next/head";
import { isLoggedIn } from "@utils/user/userCheck";
import { getBlogPosts } from "@queries/blogs.queries";
import { useContext, useEffect } from "react";
import { Store } from "@store";
import { useTranslation } from "react-i18next";
import { setLanugage } from "@utils/api/axiosInstance";
import BlogsView from "src/blogModule/views/BlogsView";

export default function BlogsPage({ blogsData, userData, lang }) {
  const { t } = useTranslation();
  const { dispatch } = useContext(Store);

  useEffect(() => {
    dispatch({ type: "SET_DATA", payload: { userData, lang } });
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Head>
        <title>{t("blogs-or-utsav-hindu-temple-online-puja-and-prasad")}</title>
        <meta
          name="keywords"
          content={t(
            "utsav-utsavapp-index-page-of-utsav-app-online-puja-booking-online-puja-online-darshan-hindi-devotional-puja-app-darshan-app-online-puja-app-free-online-puja-hinduism-sanatan-dharma-lord-shiva-lord-krishna-indian-heritage-virtual-festivals-virtual-puja-locate-various-temple-connect-with-community-temples-of-india-festivals-community-platform-download-utsav-app-community-events-india-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief"
          )}
        />
        <meta
          name="description"
          content={t('read-blogs-on-powerful-myntra-stotras-puranas-arti-and-chalisa-on-utsav-app-download-the-app-and-start-your-spiritual-journey-and-gain-knowledge-with-us')}
        />

        <meta
          property="og:title"
          content={t("utsav-app-my-temple-and-festivals")}
        />

        <meta
          property="og:description"
          content={t(
            "utsav-is-indias-no-1-spiritual-network-app-join-the-community-of-famous-temples-spiritual-gurus-and-astrologers-to-offer-online-puja-and-get-daily-darshan"
          )}
        />

        <meta property="og:url" content="https://utsavapp.in/blogs" />
        <meta
          property="og:image"
          content="https://d3k1i85mml78tf.cloudfront.net/Feeds/1705393164851_post_image_2.jpg"
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://utsavapp.in/blogs" />
      </Head>

      {/* <Blogs data={blogsData} /> */}

      <BlogsView data={blogsData}/>
    </div>
  );
}

export async function getServerSideProps(context) {
  const { req, res, locale } = context;

  try {
    const result = await isLoggedIn(req.headers.cookie, res);
    const userData = result.data;
    //const lang = result.lang;
    let lang = locale;
    setLanugage(lang);

    //printInConsole("userData => ", result)

    const { data, err } = await getBlogPosts({
      // accessToken: userData.accessToken,
      
    });

    if (err) {
      return {
        redirect: {
          destination: "/home",
          permanent: false,
        },
      };
    }

    return {
      props: {
        blogsData: data,
        userData: userData,
        lang: lang,
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/home",
        permanent: false,
      },
    };
  }
}
